var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.165 16.4198C15.485 16.7198 15.485 17.2398 15.185 17.5598C15.025 17.7198 14.825 17.7998 14.605 17.7998C14.405 17.7998 14.205 17.7198 14.045 17.5798L8.84497 12.5798C8.68497 12.4198 8.60498 12.2198 8.60498 11.9998C8.60498 11.7798 8.68497 11.5798 8.84497 11.4198L14.045 6.41983C14.365 6.11983 14.865 6.11983 15.185 6.43983C15.485 6.75983 15.485 7.25982 15.165 7.57982L10.565 11.9998L15.165 16.4198Z","fill":"white"}));
}

ArrowInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
